import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "simple-business-table" }
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = { class: "body-container" }
const _hoisted_4 = { class: "editable-cell__edit-content edit-content" }
const _hoisted_5 = { class: "editable-cell__edit-content edit-content" }

import { i18n } from '@/i18n';
import { businessContentName } from '@/appLogic/business/businessTableHeaders';
import TableCell from '@/components/atom/TableCell.vue';
import TableHead from '@/components/atom/TableHead.vue';
import { getDisplayArrivalOrSalesResultLabel, getArrivalOrSalesResultLabel } from '@/appLogic/business/businessLogic'; // TODO: 移動対象
import { initialForecast } from '@/appLogic/importData/initialData';
import IconButton from '@/components/input/Btn/IconButton.vue';
import { nullOrUndefinedToMinusOne } from '@/coreDomainsModule/extends/number';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { TableType } from '@/coreDomainsModule/table';
import { TableCommonViewModel, TableContentViewModel } from '@/viewModels/tableContent';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleBusinessTableContent',
  props: {
    tableType: {},
    items: {},
    scrollEnable: { type: Boolean, default: false },
    editableLeadTime: { type: Boolean, default: false },
    editableStdInventory: { type: Boolean, default: false }
  },
  emits: ["onClickLeadTimeButton", "onClickStdInventoryButton"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "8ca123c6": (props.scrollEnable ? `scroll` : `hidden`)
}))

const props = __props;

// emits
const emits = __emit;

//変数
const t = i18n.t;
const commonTableContentVm = new TableCommonViewModel();
const vm = new TableContentViewModel();

// 関数
const onClickLeadTimeButton = (event: MouseEvent) => {
  emits('onClickLeadTimeButton', event);
};
const onClickStdInventoryButton = (event: MouseEvent) => {
  emits('onClickStdInventoryButton', event);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commonTableContentVm).displayHeaders[_ctx.tableType], (property, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (
                _unref(commonTableContentVm).mvpSimpleTableDisplayContents(property) ||
                _unref(commonTableContentVm).commonTableDisplayContents(property) ||
                property === 'stdInventoryIndex'
              )
                ? (_openBlock(), _createBlock(TableHead, {
                    key: 0,
                    label: _unref(businessContentName)[property],
                    "text-align": 'left',
                    scope: "col"
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true),
              (property === 'arrivals' || property === 'salesResults')
                ? (_openBlock(), _createBlock(TableHead, {
                    key: 1,
                    label: _unref(getArrivalOrSalesResultLabel)(property)
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true),
              (property === 'announce-1')
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(initialForecast).customerAnnounce, (announce, indexAnnounce) => {
                    return (_openBlock(), _createBlock(TableHead, {
                      key: index + indexAnnounce,
                      label: _unref(vm).getForecastLabel(indexAnnounce)
                    }, null, 8, ["label"]))
                  }), 128))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, itemIndex) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: itemIndex,
            class: "item-container"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commonTableContentVm).displayHeaders[_ctx.tableType], (property, propertyIndex) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: propertyIndex }, [
                (
                  _unref(commonTableContentVm).mvpSimpleTableDisplayContents(property) || _unref(commonTableContentVm).commonTableDisplayContents(property)
                )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (property === 'inventory' || property === 'package')
                        ? (_openBlock(), _createBlock(TableCell, {
                            key: 0,
                            "row-value": _unref(vm).getDisplayValue(item[property], property),
                            "text-align": 'center'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(vm).getDisplayValue(item[property], property)), 1)
                            ], undefined, true),
                            _: 2
                          }, 1032, ["row-value"]))
                        : (property === 'leadTime')
                          ? (_openBlock(), _createBlock(TableCell, {
                              key: 1,
                              class: "editable-cell",
                              "row-value": _unref(vm).getDisplayValue(item[property], property),
                              "text-align": 'center'
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(vm).getLeadTime(_unref(nullOrUndefinedToMinusOne)(item[property]))), 1)
                              ], undefined, true),
                              _: 2
                            }, 1032, ["row-value"]))
                          : (_openBlock(), _createBlock(TableCell, {
                              key: 2,
                              "tool-tip-value": _unref(vm).getDisplayValue(item[property], property),
                              "text-align": 'left'
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(vm).getDisplayValue(item[property], property)), 1)
                              ], undefined, true),
                              _: 2
                            }, 1032, ["tool-tip-value"]))
                    ], 64))
                  : _createCommentVNode("", true),
                (property === 'stdInventoryIndex')
                  ? (_openBlock(), _createBlock(TableCell, {
                      key: 1,
                      class: "item-container__std-inventory-index editable-cell"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(vm).getDisplayStdInventory(item)), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (property === 'arrivals' || property === 'salesResults')
                  ? (_openBlock(), _createBlock(TableCell, {
                      key: 2,
                      "text-align": 'right'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getDisplayArrivalOrSalesResultLabel)(item.arrivals ?? [])), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (property === 'announce-1')
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_unref(vm).fetchForecastSpecifiedMonthsMinutes(item.customerAnnounce), (announce, announce_index) => {
                      return (_openBlock(), _createBlock(TableCell, {
                        key: _ctx.contentIndex + announce_index,
                        "text-align": 'right'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(vm).getDisplayForecast(announce)), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024))
                    }), 128))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})